import { Injectable } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { PersonaService } from '@core/services/persona.service';

/**
 * This guard is used to display unanswered questions to a user when logging in.
 */
@Injectable({ providedIn: 'root' })
export class PersonaGuard  {

  constructor (
    private personaService: PersonaService,
    private authService: AuthService
  ) { }

  canActivateChild () {
    //  feature only applies to non internal users
    if (this.authService.isInternalUser()) {
      return Promise.resolve(true);
    }

    //  logic for fetching modal is handled within service
    return this.personaService.getUnansweredPersonaQuestionsForUserModalForSigningIn();
  }
}
